var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container flex justify-center items-center"},[(!_vm.isLoading)?_c('v-chart',{ref:"chart",staticClass:"rounded-lg border border-gray-200",attrs:{"options":_vm.chartOptions,"autoresize":true}}):_c('div',{staticClass:"skeleton-chart"},_vm._l((4),function(n){return _c('div',{key:n,staticClass:"skeleton-bar"})}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }